module.exports = __webpack_public_path__ + "img/plus-stroke.3a18d420.svg";